import React from 'react'
import PropTypes from 'prop-types'
import { Article } from '../components/Article'
import board2 from '../images/board2.jpg'

export function A02({ index }) {
  return (
    <Article
      index={index}
      heading="The entrepreneur wants more business traction, so she creates a tokenized economy to support viral loops."
      image={board2}
      imageDescription="Alice's app has gone viral!"
    >
      <div className="article-row">
        <span>
          <p>
            App-based tokens can be used to generate micro-economies within
            products that help bootstrap app ecosystems and adoption. Though
            viral loops aren't unique to the Internet Computer, the platform
            uniquely makes it possible for users to easily support them using a
            new tool: tokenized economics.
            <br />
            <br />
            Through tokenization, the users of a service become the team that
            drives it.
            <br />
            <br />
            In the video below, you'll see different ways to apply tokenized
            economics to support app adoption (along with the associated code).
          </p>

          <h4>Tokenization makes the CanCan concept more compelling</h4>
          <p>
            Open internet services run autonomously as part of the internet,
            just like blockchains, enabling the implementation of highly viral,
            growth-driving token systems.
          </p>
        </span>
        <aside>
          <h4>How does tokenization work?</h4>
          <p>
            Each user is able to “Super Like” up to 10 videos every 24 hours.
            <br />
            <br />
            When a video goes viral, CanCan looks at the order in which super
            likes were made.
            <br />
            <br />
            Users who super liked a viral video early on participate in a reward
            point “Shower.”
            <br />
            <br />
            Periodically, there is a “Drop Day” when the reward points can be
            exchanged.
            <br />
            <br />
            Users can exchange points for governance tokens and become CanCan
            “owners.”
            <br />
            <br />
            Users can exchange points for prizes from sponsors, who then use
            them to pay for ads on the app.
            <br />
            <br />
            Users can tip video creators by sending them red letters full of
            rewards points.
          </p>
        </aside>
      </div>
    </Article>
  )
}

A02.propTypes = {
  index: PropTypes.number.isRequired,
}
